import axios from '@axios'
import { uploader, storePagination, sorting } from '@/mixins'
import Decimal from 'decimal.js-light'

const getInitialState = () => ({
  ...storePagination.state(),
  filters: {
    value: null,
    status: null,
    inputMethod: null
  },
  conciliation: {
    id: null,
    store: null,
    checkingAccount: {
      id: null,
      name: null,
    },
    fileUrl: null,
    fileOrigin: null,
    fileName: null,
    receivedDate: null,
    processedDate: null,
    percentCompleted: null,
    status: null,
  },
  summaryFields: {
    erpTotalValue: {},
    transactionTotalValue: {},
  },
  conciliationItems: [],
  allConciliationItems: [],
  conciliationFile: [],
})

export default {
  namespaced: true,
  state: getInitialState(),
  mutations: {
    ...storePagination.mutations,
    SET_CONCILIATION(state, conciliation) {
      state.conciliation = conciliation
    },
    SET_CONCILIATION_ITEMS(state, items) {
      state.conciliationItems = items
    },
    SET_SUMMARY_FIELDS(state, summaryFields) {
      state.summaryFields = summaryFields
    },
    SET_ALL_CONCILIATION_ITEMS(state, items) {
      state.allConciliationItems = items
    },
    SET_CONCILIATION_FILE(state, file) {
      state.conciliationFile = file
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },

    CLEAN_STATE(state) {
      const {
        conciliation,
        conciliationItems,
        conciliationFile,
        filters,
      } = getInitialState()
      state.conciliation = conciliation
      state.conciliationItems = conciliationItems
      state.conciliationFile = conciliationFile
      state.filters = filters
    },
  },
  actions: {
    ...storePagination.actions,
    async sendConciliationFile({ commit }, { file }) {
      const result = await uploader.methods.uploadCustom({
        file,
        apiUrl: '/api/financial/reconciliation/santander/pix',
        fileParamName: 'file',
      })
      commit('SET_CONCILIATION', result)
      return result.id
    },
    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
    async fetchConciliation({ commit }, id) {
      const { data } = await axios.get(`/api/financial/reconciliation/santander/pix/${id}`)
      commit('SET_CONCILIATION', data)
    },
    async fetchConciliationItems({ commit, state }, id) {
      const { filters } = state

      const filterValue = new Decimal(filters.value || 0).toNumber()

      const params = {
        status: filters.status,
        inputMethod: filters.inputMethod,
        value: filterValue || undefined,
        sortBy: sorting.methods.getSorting(state),
        pageSize: state.paging.pageSize,
        pageIndex: state.paging.currentPage - 1,
      }
      const { data } = await axios.get(`/api/financial/reconciliation/santander/pix/${id}/items`, {
        params,
      })
      commit('SET_CONCILIATION_ITEMS', data.results)
      commit('SET_SUMMARY_FIELDS', data.summaryFields)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },
    async fetchAllConciliationItems({ commit }, id) {
      const params = {
        pageSize: 99999999,
        pageIndex: 0,
      }
      const { data } = await axios.get(`/api/financial/reconciliation/santander/pix/${id}/items`, {
        params,
      })
      commit('SET_ALL_CONCILIATION_ITEMS', data.results)
    },

    async finishConciliation({ commit }, conciliationId) {
      const { data } = await axios.put(
        `/api/financial/reconciliation/santander/pix/${conciliationId}/finish`
      )
      commit('SET_CONCILIATION', data)
    },
    async matchItem({ dispatch }, { conciliationId, itemId, receivableInstallmentIds }) {
      await axios.put(
        `/api/financial/reconciliation/santander/pix/${conciliationId}/items/${itemId}/match`,
        {
          receivableInstallmentIds,
        }
      )
      await dispatch('fetchConciliation', conciliationId)
      await dispatch('fetchConciliationItems', conciliationId)
    },
    async unmatchItem({ dispatch }, { conciliationId, itemId, receivableInstallmentIds }) {
      await axios.put(
        `/api/financial/reconciliation/santander/pix/${conciliationId}/items/${itemId}/unmatch`,
        {
          receivableInstallmentIds,
        }
      )
      await dispatch('fetchConciliation', conciliationId)
      await dispatch('fetchConciliationItems', conciliationId)
    },
    async resetItem({ dispatch }, { conciliationId, item }) {
      await axios.put(
        `/api/financial/reconciliation/santander/pix/${conciliationId}/items/${item.id}/reset`
      )
      await dispatch('fetchConciliation', conciliationId)
      await dispatch('fetchConciliationItems', conciliationId)
    },
    async skipItem({ dispatch }, { conciliationId, itemId, comments }) {
      await axios.put(
        `/api/financial/reconciliation/santander/pix/${conciliationId}/items/${itemId}/skip`,
        {
          comments,
        }
      )
      await dispatch('fetchConciliation', conciliationId)
      await dispatch('fetchConciliationItems', conciliationId)
    },
    setConciliationFile({ commit }, file) {
      commit('SET_CONCILIATION_FILE', file)
    },
    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },
  },
}
